/**
 * Core value objects for contact and address details.
 */
import { z } from 'zod';

// ============================================================================
// Address
// ============================================================================

export const AddressSchema = z.object({
  street: z.string().min(1),
  city: z.string().min(1),
  state: z.string().min(1),
  zipCode: z.string().regex(/^\d{5}(-\d{4})?$/, 'Invalid ZIP code format'),
});
export type Address = z.infer<typeof AddressSchema>;

// ============================================================================
// Contact Info
// ============================================================================

export const EmailSchema = z.string().email().brand('Email');
export type Email = z.infer<typeof EmailSchema>;

export const PhoneNumberSchema = z.string()
  .regex(/^[\d\s\-().+]+$/, 'Invalid phone number format')
  .min(10)
  .brand('PhoneNumber');
export type PhoneNumber = z.infer<typeof PhoneNumberSchema>;

export const ContactInfoSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: EmailSchema,
  phone: PhoneNumberSchema,
  address: AddressSchema,
});
export type ContactInfo = z.infer<typeof ContactInfoSchema>;
